(function () {
    'use strict';

    if (typeof window === 'undefined') {

        module.exports = exportFn(
            require('lodash')
        );

    } else {

        RivalIQ.apps.Insights.module('utils', function (utils, App, Backbone, Marionette, $, _) {
            _.extend(utils, exportFn(
                window._
            ));
        });
    }

    function exportFn(_) {
        const INSTAGRAM_ENGAGEMENT_MAP_TYPE = {
            ORGANIC: 1,
            PAID: 2,
            ALL: 3
        };

        function defaultReplacer(label, property) {
            return [label, property].join('_');
        }

        function invertedReplacer(label, property) {
            return [property, label].join('_');
        }

        const instagramPaidProperties = [
            {
                property: 'engagement_total',
                mapType: INSTAGRAM_ENGAGEMENT_MAP_TYPE.ALL
            },
            {
                property: 'engagement_total_per_post',
                mapType: INSTAGRAM_ENGAGEMENT_MAP_TYPE.ALL
            },
            {
                property: 'engagement_rate',
                aggregate: false,
                mapType: INSTAGRAM_ENGAGEMENT_MAP_TYPE.ALL
            },
            {
                property: 'engagement_rate_per_post',
                aggregate: false,
                mapType: INSTAGRAM_ENGAGEMENT_MAP_TYPE.ALL
            },
            {
                property: 'engagement_rate_by_reach',
                aggregate: false,
                mapType: INSTAGRAM_ENGAGEMENT_MAP_TYPE.ALL
            },
            {
                property: 'engagement_rate_by_impression',
                mapType: INSTAGRAM_ENGAGEMENT_MAP_TYPE.ALL
            },
            {
                property: 'likes',
                mapType: INSTAGRAM_ENGAGEMENT_MAP_TYPE.ALL
            },
            {
                property: 'likes_per_post',
                mapType: INSTAGRAM_ENGAGEMENT_MAP_TYPE.ALL
            },
            {
                property: 'comments',
                mapType: INSTAGRAM_ENGAGEMENT_MAP_TYPE.ALL
            },
            {
                property: 'comments_per_post',
                mapType: INSTAGRAM_ENGAGEMENT_MAP_TYPE.ALL
            },
            {
                property: 'saves',
                mapType: INSTAGRAM_ENGAGEMENT_MAP_TYPE.ALL
            },
            {
                property: 'saves_per_post',
                mapType: INSTAGRAM_ENGAGEMENT_MAP_TYPE.ALL
            },
            {
                property: 'shares',
                mapType: INSTAGRAM_ENGAGEMENT_MAP_TYPE.ALL
            },
            {
                property: 'shares_per_post',
                mapType: INSTAGRAM_ENGAGEMENT_MAP_TYPE.ALL
            },
            {
                property: 'impressions',
                mapType: INSTAGRAM_ENGAGEMENT_MAP_TYPE.ALL
            },
            {
                property: 'impressions_per_post',
                mapType: INSTAGRAM_ENGAGEMENT_MAP_TYPE.ALL
            },
            {
                property: 'reach',
                aggregate: false,
                mapType: INSTAGRAM_ENGAGEMENT_MAP_TYPE.ALL
            },
            {
                property: 'reach_rate',
                aggregate: false,
                mapType: INSTAGRAM_ENGAGEMENT_MAP_TYPE.ALL
            },
            {
                property: 'reach_per_post',
                aggregate: false,
                mapType: INSTAGRAM_ENGAGEMENT_MAP_TYPE.ALL
            },
            {
                property: 'reach_rate_per_post',
                aggregate: false,
                mapType: INSTAGRAM_ENGAGEMENT_MAP_TYPE.ALL
            },
            {
                property: 'video_views',
                mapType: INSTAGRAM_ENGAGEMENT_MAP_TYPE.ALL
            },
            {
                property: 'video_views_per_post',
                mapType: INSTAGRAM_ENGAGEMENT_MAP_TYPE.ALL
            },
            {
                property: 'video_view_rate',
                mapType: INSTAGRAM_ENGAGEMENT_MAP_TYPE.ALL
            },
            {
                property: 'video_views_per_user',
                aggregate: false,
                mapType: INSTAGRAM_ENGAGEMENT_MAP_TYPE.ALL
            },
            {
                property: 'link_clicks',
                mapType: INSTAGRAM_ENGAGEMENT_MAP_TYPE.PAID,
                aggregate: false
            },
            {
                property: 'social_engagement_total',
                mapType: INSTAGRAM_ENGAGEMENT_MAP_TYPE.ALL
            },
            {
                property: 'social_engagement_rate_by_reach',
                aggregate: false,
                mapType: INSTAGRAM_ENGAGEMENT_MAP_TYPE.ALL,
                // For consistency with facebook metrics, social_engagement_rate_by_reach is expanded
                // into social_engagement_rate_by_reach_organic and social_engagement_rate_by_reach_paid.
                replacer: invertedReplacer
            },
            {
                property: 'social_engagement_rate_by_impression',
                mapType: INSTAGRAM_ENGAGEMENT_MAP_TYPE.ALL
            }
        ];

        const utils = {};

        utils.getInstagramPaidEngagementMappedProperty = function (property, hasPaidEngagement) {
            const config = _.find(instagramPaidProperties, {
                property: property
            });

            if (!hasPaidEngagement || (_.get(config, ['aggregate']) === false)) {
                return utils.getInstagramPaidEngagementProperty(property, INSTAGRAM_ENGAGEMENT_MAP_TYPE.ORGANIC);
            }

            return property;
        };

        utils.getInstagramPaidEngagementProperty = function (property, engagementMapType) {
            const config = _.find(instagramPaidProperties, {
                property: property
            });

            if (!config || (config.mapType & engagementMapType) !== engagementMapType) {
                return property;
            }

            const label = _.find(_.keys(INSTAGRAM_ENGAGEMENT_MAP_TYPE), function (key) {
                return (INSTAGRAM_ENGAGEMENT_MAP_TYPE[key] === engagementMapType);
            }).toLowerCase();

            const replacer = config.replacer || defaultReplacer;

            return replacer(label, property);
        };

        utils.instagramPaidEngagementPropertyReducer = function (hasPaidEngagement) {
            return function (memo, property) {
                const config = _.find(instagramPaidProperties, {
                    property: property
                });

                if (config) {
                    const replacer = config.replacer || defaultReplacer;
                    if (hasPaidEngagement) {
                        return _.reduce([INSTAGRAM_ENGAGEMENT_MAP_TYPE.ORGANIC, INSTAGRAM_ENGAGEMENT_MAP_TYPE.PAID], function (memo, type) {
                            if ((config.mapType & type) === type) {
                                const label = _.find(_.keys(INSTAGRAM_ENGAGEMENT_MAP_TYPE), function (key) {
                                    return (INSTAGRAM_ENGAGEMENT_MAP_TYPE[key] === type);
                                }).toLowerCase();

                                return memo.concat(replacer(label, property));
                            }

                            return memo;
                        }, (config.aggregate !== false ? memo.concat(property) : memo));
                    } else if (config.mapType === INSTAGRAM_ENGAGEMENT_MAP_TYPE.PAID) {
                        // If this property is for paid only and the user doesn't have paid engagement, don't add this property
                        // to their set of metrics.
                        return memo;
                    }
                    property = replacer('organic', property);
                }

                return memo.concat(property);
            };
        };


        return utils;
    }

})();
